<template>
    <div class="launch-version-banner">
        <div class="launch-version-banner__text">
            温馨提示：经典版（旧版）将于【{{ offlineDate }}】正式下线，感谢您的陪伴。
        </div>
        <div class="launch-version-banner__actions">
            <button
                v-if="current === 'new'"
                type="button"
                class="launch-version-banner__btn"
                @click="switchToOld"
            >
                返回旧版
            </button>
            <button
                v-else
                type="button"
                class="launch-version-banner__btn"
                @click="switchToNew"
            >
                使用新版
            </button>
        </div>
    </div>
</template>

<script>
import {
    LAUNCH_EDITION,
    CLASSIC_OFFLINE_DATE,
    setLaunchEdition
} from '@/utils/launchVersion'

export default {
    name: 'LaunchVersionBanner',
    props: {
        /** 当前页面版本：new | old */
        current: {
            type: String,
            default: 'new'
        }
    },
    data() {
        return {
            offlineDate: CLASSIC_OFFLINE_DATE
        }
    },
    methods: {
        switchToOld() {
            setLaunchEdition(LAUNCH_EDITION.OLD)
            if (this.$route.path !== '/sign/index') {
                this.$router.replace({ path: '/sign/index', query: this.$route.query })
            }
        },
        switchToNew() {
            setLaunchEdition(LAUNCH_EDITION.NEW)
            if (this.$route.path !== '/sign/launch') {
                this.$router.replace({ path: '/sign/launch', query: this.$route.query })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.launch-version-banner {
    background: #fff;
    border-radius: 8px;
    padding: 14px 20px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border: 1px solid #e8e8e8;
}

.launch-version-banner__text {
    flex: 1;
    font-size: 14px;
    line-height: 22px;
    color: #4a5568;
}

.launch-version-banner__actions {
    flex-shrink: 0;
}

.launch-version-banner__btn {
    min-width: 88px;
    height: 32px;
    padding: 0 14px;
    border-radius: 4px;
    border: 1px solid #4877e8;
    background: #fff;
    color: #4877e8;
    font-size: 14px;
    cursor: pointer;
    line-height: 30px;
}

@media (max-width: 768px) {
    .launch-version-banner {
        flex-direction: column;
        align-items: stretch;
    }

    .launch-version-banner__actions {
        display: flex;
        justify-content: center;
    }
}
</style>
